// Models
import { DeviceUnitViewModel } from '../../../unit-config/services/device.service';
import { UnitViewModel } from '../models/unit-view.model';

export namespace DeviceUnitActions {
	export class GetAll {
		static readonly type = '[Device Unit] Get Device Units';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Device Unit] Set Device Units';
		constructor(public deviceUnits: DeviceUnitViewModel[]) {}
	}

	export class Activate {
		static readonly type = '[Device Unit] Activate Device Unit';
		constructor(public data: { unit: UnitViewModel; showSpinner?: boolean; showToast?: boolean } = { unit: null, showSpinner: false, showToast: false }) {}
	}

	export class ActivateSuccess {
		static readonly type = '[Device Unit] Activate Device Unit Success';
		constructor() {}
	}

	export class Deactivate {
		static readonly type = '[Device Unit] Deactivate Device Unit';
		constructor(public data: { deviceUnit: DeviceUnitViewModel; showSpinner?: boolean; showToast?: boolean; showConfirm?: boolean } = { deviceUnit: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}

	export class DeactivateSuccess {
		static readonly type = '[Device Unit] Deactivate Device Unit Success';
		constructor() {}
	}

	export class DeactivateTemporary {
		static readonly type = '[Device Unit] Deactivate Temporary Device Unit';
		constructor(public data: { deviceUnit: DeviceUnitViewModel; showSpinner?: boolean; showToast?: boolean; showConfirm?: boolean } = { deviceUnit: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}

	export class DeactivateTemporarySuccess {
		static readonly type = '[Device Unit] Deactivate Temporary Device Unit Success';
		constructor() {}
	}

	export class Toggle {
		static readonly type = '[Device Unit] Toggle Device Unit';
		constructor(public data: { deviceUnit: DeviceUnitViewModel; showSpinner?: boolean; showToast?: boolean; showConfirm?: boolean } = { deviceUnit: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}

	export class ToggleSuccess {
		static readonly type = '[Device Unit] Toggle Device Unit Success';
		constructor(enabling: boolean) {}
	}

	export class Add {
		static readonly type = '[Device Unit] Add Temporary Device Unit';
		constructor(public deviceUnit: DeviceUnitViewModel) {}
	}

	export class Modify {
		static readonly type = '[Device Unit] Modify Temporary Device Unit';
		constructor(public deviceUnit: DeviceUnitViewModel) {}
	}

	export class Delete {
		static readonly type = '[Device Unit] Delete Device Unit';
		constructor(public id: number) {}
	}
}
